import styled from 'styled-components';

export const ChartWrapper = styled.div`
    position: relative;
`;
